export default "__VITE_ASSET__sg_dpk1e__"